import { GaugeBands } from "../../types/graph";

export const getGaugeColour = (bandTitle: string, bands: GaugeBands[]) => {
  return bands.find((band) => bandTitle === band.bandTitle)?.bandColour || "";
};

export const getGaugeLabel = (score: number, bands: GaugeBands[]) => {
  return bands.find((band) => score <= band.bandLimit)?.bandTitle || "";
};
